import {
  ColorInputProps as MantineColorInputProps,
  ColorInput as MantineColorInput,
} from '@mantine/core';

export type ColorInputProps = MantineColorInputProps;

export const ColorInput = MantineColorInput;

ColorInput.displayName = 'ColorInput';
